import { useEffect, useState } from "react";
import { getResearchQueryDetail } from "../services/rulesService";
import { getResearchQueryByIdDetail } from "../services/comparisonResearchQueries";

interface IuseFetchComparisonResearchQueryById {
  setIsLoading: any;
  comparisonId: any;
}

const useFetchComparisonResearchQueryById = ({
  setIsLoading,
  comparisonId,
}: IuseFetchComparisonResearchQueryById) => {
  const [comparisonResearchQueryByIdDetail, setComparisonResearchQueryByIdDetail] =
    useState<any>({});
  useEffect(() => {
    setIsLoading(true);
    if (comparisonId && comparisonId > 0) {
      const getComparisonResearchQueryByIdData = async () => {
        try {
          const result = await getResearchQueryByIdDetail(comparisonId);
          setComparisonResearchQueryByIdDetail(result);
        } catch (err) {
          setComparisonResearchQueryByIdDetail({});
        } finally {
          setIsLoading(false);
        }
      };

      getComparisonResearchQueryByIdData();
    }
  }, [comparisonId]);

  return [comparisonResearchQueryByIdDetail];
};

export default useFetchComparisonResearchQueryById;

